/**
 * Class constants for the dialog surface.
 *
 * Classes live here rather than inline so the visual contract of the dialog is
 * readable in one place. Every colour is a token from `styles/globals.css`;
 * a raw palette class here would drift from the theme the moment a token moves.
 */

export const dialogStyles = {
  trigger:
    'inline-flex items-center justify-center gap-2 rounded-control border border-border-strong bg-surface-raised px-3 py-2 text-sm font-medium text-content transition-colors hover:bg-surface-sunken disabled:pointer-events-none disabled:opacity-50',

  backdrop:
    'fixed inset-0 z-40 bg-content/40 transition-opacity duration-150 data-[starting-style]:opacity-0 data-[ending-style]:opacity-0',

  viewport:
    'fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-4 transition-opacity duration-150 data-[starting-style]:opacity-0 data-[ending-style]:opacity-0',

  popup:
    'w-full max-w-lg rounded-surface border border-border bg-surface-raised p-6 shadow-lg transition-transform duration-150 data-[starting-style]:scale-95 data-[starting-style]:opacity-0 data-[ending-style]:scale-95 data-[ending-style]:opacity-0',

  header: 'flex flex-col gap-1.5',

  title: 'text-lg font-semibold text-content',

  description: 'text-sm text-content-muted',

  footer: 'mt-6 flex flex-wrap items-center justify-end gap-2',

  close:
    'inline-flex items-center justify-center rounded-control border border-border-strong bg-surface-raised px-3 py-2 text-sm font-medium text-content transition-colors hover:bg-surface-sunken',
} as const;